import { combineReducers, createStore } from 'redux';
import {
  record,
  schema,
  createActor,
  createReducer,
  createSelector,
} from '@sharingapples/redux';

import { isBrowser } from '../lib/utils';
import { updateCart } from './cart';
import { fetchInvoice } from '../services/cart';
import { InvoiceStorage } from '../screens/Cart/helpers';

const structure = {
  invoice: record('invoice'),
  orders: schema('orders'),
};

const reducer = combineReducers(createReducer(structure));
const store = createStore(
  reducer,
  // eslint-disable-next-line no-underscore-dangle
  isBrowser() && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

(async function initStoreWithData() {
  if (isBrowser()) {
    const invoiceId = InvoiceStorage.get();
    
    if (invoiceId) {
      try {
        const cartData = await fetchInvoice(invoiceId);
        updateCart(cartData);
      } catch (err) {
        console.log(err);
      }
    }
  }
})();

export const useSelector = createSelector(structure, store);
export const reduxDB = createActor(structure, store.dispatch);



// WEBPACK FOOTER //
// ./src/redux/reduxDB.js